import {FirebaseHelper} from "./FirebaseHelper";
import {asString} from 'date-format'

class StringHelper {
    static getLastPartOfUrl(url) {
        return JSON.stringify(url).split("/").pop().replace(/['"]+/g, '')
    }
}

const setToOriginalState = (actions) => {
    actions.setShowProgress(false)
    actions.setLink("")
    actions.setAddObj({message: ""})
    actions.setShowObj({message: ""})
}

const getShareLink = (id) => {
    var url = new URL(window.location.href)
    return `${url.origin}/${id}`
}

export class BusinessLogics {
    static addData(state, actions) {
        actions.setShowProgress(true)

        FirebaseHelper.addData({
            message: state.add.message,
            deleted: false,
            dt: asString(`hh:mm:ss-dd/MM/yy`, new Date())
        }, (data) => {
            const dataId = StringHelper.getLastPartOfUrl(data)
            console.log(`ADDED: ${dataId}`)
            actions.setShowProgress(false)

            // console.log(`TEST: ${getShareLink(dataId)}`)
            actions.setLink(getShareLink(dataId))
            actions.setSnackbarMessage("Message saved. Copy the link and share to show the message.")
        })
    }

    static deleteData(state, actions, changeRoute) {
        actions.setShowProgress(true)

        FirebaseHelper.updateOneData(StringHelper.getLastPartOfUrl(state.link), (err) => {
            setToOriginalState(actions)
            changeRoute('/')
            actions.setSnackbarMessage("Message deleted!!!")
        })
    }

    static getOneData(id, actions, changeRoute) {
        actions.setShowProgress(true)

        FirebaseHelper.getOneData(id, (data) => {
            console.log(`GET: ${JSON.stringify(data)}`)
            console.log(data.val().message)

            setToOriginalState(actions)

            if (data.val()) {
                if (data.val().deleted) {
                    changeRoute('/')
                    actions.setSnackbarMessage("Either the message is deleted or the link is incorrect")
                } else {
                    actions.setShowObj({
                        message: data.val().message
                    })

                    console.log(`TEST: ${getShareLink(id)}`)
                    actions.setLink(getShareLink(id))
                }
            } else {
                changeRoute('/')
                actions.setSnackbarMessage("Either the message is deleted or the link is incorrect")
            }
        })
    }
}
